import React from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";

import { FieldWrapper, FieldWrapperProps, InputFieldProps } from "shared/components";

import { ColorPreview, StyledColorField, ColorFieldWrapper } from "./styles";
import { COLOR_REGEX, PARTIAL_COLOR_REGEX } from "./utils";

interface ColorFieldProps extends FieldWrapperProps, InputFieldProps {
  control: Control;
  validation?: RegisterOptions;
  value?: string | null;
}

export const ColorField: React.FC<ColorFieldProps> = ({
  control,
  validation,
  error,
  disabled,
  readOnly,
  placeholder = "#000000",
  name,
  value,
  ...props
}) => {
  return (
    <FieldWrapper name={name} error={error} {...props}>
      <ColorFieldWrapper isDisabled={disabled || readOnly} error={!!error}>
        <ColorPreview
          data-testid="color_preview"
          color={COLOR_REGEX.test(value || "") ? (value as string) : undefined}
        />
        <Controller
          name={name}
          control={control}
          rules={validation}
          render={({ onChange }) => (
            <StyledColorField
              type="text"
              id={name}
              name={name}
              placeholder={placeholder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value;
                if (PARTIAL_COLOR_REGEX.test(value) || value === "") {
                  onChange(value);
                }
              }}
              value={value || ""}
              disabled={disabled}
              readOnly={readOnly}
            ></StyledColorField>
          )}
        />
      </ColorFieldWrapper>
    </FieldWrapper>
  );
};
